import axios from "axios";
import {
    PROFILE,
    BILLS,
    DOCUMENT,
    COMPANY,
    PROFILE_DOCUMENT_V2,
    PROFILE_VERIFICATION_V2,
} from "../endpointsConst";

const ProfileService = {};

ProfileService.getProfileData = () => axios.get(PROFILE);

ProfileService.editProfileData = (data) => axios.put(PROFILE, data);

ProfileService.editCompanyLogo = (id, data) =>
    axios.patch(COMPANY.PATCH_LOGO + id, data);

ProfileService.getBills = () => axios.get(PROFILE + BILLS);

ProfileService.addBill = (data) => axios.post(PROFILE + BILLS, data);

ProfileService.deleteBill = (id) => axios.delete(PROFILE + BILLS + `/${id}`);

ProfileService.getDocuments = (data) =>
    axios.get(PROFILE_DOCUMENT_V2, { params: { ...data } });

ProfileService.deleteDocument = (id) => axios.delete(PROFILE_DOCUMENT_V2 + `/${id}`);

ProfileService.addDocument = (data) =>
    axios.post(PROFILE_DOCUMENT_V2, data);

ProfileService.getVerification = () => axios.get(PROFILE_VERIFICATION_V2);

/** Отправить компанию на проверку — статус переходит в «на проверке» */
ProfileService.requestVerification = () => axios.post(PROFILE_VERIFICATION_V2);

export { ProfileService };
